<ng-template #dateInput>
    <div class="input-group">
        <input
            [ngClass]="{'input-saved': state === 'updated', 'input-error': state === 'error'}"
            type="text"
            class="form-control"
            container="body"
            [formControl]="formControl"
            [minDate]="minDateValue"
            [maxDate]="maxDateValue"
            ngbDatepicker
            #datePicker="ngbDatepicker"
            [restoreFocus]="restoreFocusElement"
            [outsideDays]="outsideDaysComputed()"
            (keydown)="keyPress($event)"
            (dateSelect)="onDateSelect()"
            (blur)="onTouch?.()"
            [class.is-invalid]="
                forceInvalid || (ngControl.control?.invalid && ngControl.control?.touched)
            "
            [name]="name"
            [autocomplete]="autoComplete"
            (focus)="focus(); selectOnFocus ? $any($event.target).select() : null" />
        <button
            class="btn"
            [class.btn-input-icon]="iconStyleComputed() === 'fontawesome'"
            (click)="datePicker.toggle(); focus()"
            tabindex="-9999"
            type="button"
            [disabled]="formControl.disabled"
            [class.btn-outline-primary]="!ngControl.control?.invalid || !ngControl.control?.touched"
            [class.btn-outline-danger]="ngControl.control?.invalid && ngControl.control?.touched"
            [class.is-invalid]="ngControl.control?.invalid && ngControl.control?.touched"
            (blur)="onTouch?.()">
            @if (iconStyleComputed() === 'fontawesome') {
                <fa-icon [icon]="faCalendarAlt" transform="grow-5"></fa-icon>
            } @else {
                <i class="bi bi-calendar2-event"></i>
            }
        </button>
        @if (userName != null) {
            <div class="form-control-plaintext ms-1" style="width: auto">{{ userName }}</div>
        }
    </div>

    @if (ngControl.control != null) {
        <app-control-messages [control]="ngControl.control"></app-control-messages>
    }
</ng-template>

@if (labelCols != null && labelCols > 0) {
    <div class="form-group row">
        <label class="col-form-label" [class]="labelClass" [for]="id">{{ label }}</label>
        <div [class]="inputColsClass">
            <ng-container [ngTemplateOutlet]="dateInput" />
        </div>
    </div>
} @else {
    <div [ngClass]="{'mb-3': label.length > 0 && !noBottomMargin()}">
        @if (label.length > 0) {
            <div class="d-flex justify-content-between">
                <label class="form-label" [class]="labelClass" [for]="id">{{ label }}</label>
                @if (information) {
                    <app-popover-icon class="ms-3" [popover]="information" />
                }
            </div>
        }
        <ng-container [ngTemplateOutlet]="dateInput" />
    </div>
}
